
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Destinationweddingplacenearbhnadara() {



  const cardData =
  {
    keyword: ' Destination Wedding Place Near Bhandara',
    heading:  'Woodland Escape: Destination Wedding Place Near Bhandara ',
    headingDescription: 'Woodland Escape Resort, a stunning destination wedding place near Bhandara, offers the perfect blend of natural elegance, convenience and celebration under one roof. Set amidst verdant forest glades, open­air lawns and charming shaded walkways just a short drive from the city, the resort creates a dreamy backdrop for your wedding festivities. From intimate vow exchanges in tranquil corners to lavish receptions beneath the trees, couples can choose from scenic outdoor venues, luxurious cottage stays for guests and stylish décor that complements the natural surroundings. With dedicated event support, gourmet catering and modern guest amenities, Woodland Escape Resort near Bhandara ensures your wedding is not only beautiful but comfortable, memorable and uniquely “you”.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
{
"name": "Destination Wedding Place Near Bhandara",
"description": "Plan your dream destination wedding near Bhandara with beautiful resorts and venues offering scenic backdrops, luxury accommodations, and complete wedding arrangements for a memorable celebration."
},
{
"name": "Bhandara Wedding Venue",
"description": "Choose a top wedding venue in Bhandara for your special day, featuring elegant banquet halls, outdoor spaces, and professional services to make your wedding seamless and unforgettable."
},
{
"name": "Bhandara Luxury Wedding Location",
"description": "Host a luxurious wedding at a premium location in Bhandara with high-end amenities, lavish décor, catering services, and exclusive settings for an opulent wedding experience."
},
{
"name": "Affordable Wedding Spot Bhandara",
"description": "Find affordable wedding venues in Bhandara that combine budget-friendly options with beautiful settings, catering, and basic wedding arrangements without compromising on style."
},
{
"name": "Bhandara Pre Wedding Shoot Location",
"description": "Capture your special moments at picturesque pre-wedding shoot locations in Bhandara, including gardens, riversides, hills, and resort settings perfect for romantic photography."
},
{
"name": "Bhandara Outdoor Wedding Spot",
"description": "Opt for an outdoor wedding in Bhandara surrounded by nature, open lawns, riversides, or hilltop views, ideal for a vibrant and memorable wedding ceremony."
},
{
"name": "Bhandara Riverside Wedding Venue",
"description": "Celebrate your wedding by the riverside in Bhandara, with serene water views, scenic backdrops, and facilities to host both the ceremony and reception in a tranquil environment."
},
{
"name": "Bhandara Hill Wedding Location",
"description": "Plan a hilltop wedding in Bhandara with panoramic views, fresh air, and natural surroundings that add a majestic touch to your wedding celebration."
},
{
"name": "Bhandara Family Wedding Resort",
"description": "Choose a family-friendly wedding resort in Bhandara offering accommodations, dining, and recreation for guests, ensuring everyone enjoys the wedding in comfort and style."
},
{
"name": "Bhandara Resort Wedding Packages",
"description": "Explore comprehensive wedding packages at Bhandara resorts that include décor, catering, accommodation, and other wedding services for hassle-free planning."
},
{
"name": "Bhandara Wedding Booking Online",
"description": "Book your wedding venue online in Bhandara with ease, securing your preferred date, services, and packages for a smooth and organized wedding planning experience."
},
{
"name": "Bhandara Wedding Hall",
"description": "Host a grand celebration in a wedding hall in Bhandara, offering spacious interiors, modern facilities, and event management support for an unforgettable wedding."
},
{
"name": "Bhandara Marriage Destination",
"description": "Select Bhandara as your marriage destination with stunning resorts, scenic locations, and professional wedding services to create a memorable event for you and your guests."
},
{
"name": "Bhandara Resort for Wedding",
"description": "Plan your wedding at a dedicated resort in Bhandara with luxurious accommodations, banquet facilities, and outdoor venues suitable for both ceremonies and receptions."
},
{
"name": "Bhandara Wedding Destination Packages",
"description": "Choose from customized wedding destination packages in Bhandara including venue, catering, décor, photography, and guest accommodations for a complete wedding solution."
}
],
"tableData": [
["- Destination Wedding Place Near Bhandara", "- Bhandara Wedding Venue"],
["- Bhandara Luxury Wedding Location", "- Affordable Wedding Spot Bhandara"],
["- Bhandara Pre Wedding Shoot Location", "- Bhandara Outdoor Wedding Spot"],
["- Bhandara Riverside Wedding Venue", "- Bhandara Hill Wedding Location"],
["- Bhandara Family Wedding Resort", "- Bhandara Resort Wedding Packages"],
["- Bhandara Wedding Booking Online", "- Bhandara Wedding Hall"],
["- Bhandara Marriage Destination", "- Bhandara Resort for Wedding"],
["- Bhandara Wedding Destination Packages", ""]
],
  


whychoose: [
  {
    "WhyChooseheading": "Dream Destination Wedding Resort Near Bhandara",
    "WhyChoosedescription": "Woodland Escape Resort offers a magical forest setting near Bhandara, perfect for couples seeking a destination wedding surrounded by nature. The serene environment adds charm and elegance to your special day."
  },
  {
    "WhyChooseheading": "Enchanting Forest Ambience",
    "WhyChoosedescription": "Celebrate your wedding amidst lush greenery, tall trees, and peaceful landscapes. Woodland Escape Resort provides a tranquil and scenic backdrop that makes every wedding moment memorable and photogenic."
  },
  {
    "WhyChooseheading": "Flexible Wedding Venues",
    "WhyChoosedescription": "From open forest lawns to elegant tented setups, Woodland Escape Resort offers versatile spaces that can be customized for wedding ceremonies, receptions, and pre-wedding functions according to your vision."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation for Guests",
    "WhyChoosedescription": "Your wedding party can stay in cozy rooms and cottages nestled in the forest, offering comfort and convenience. Woodland Escape Resort ensures that guests can relax and enjoy the celebrations without leaving the venue."
  },
  {
    "WhyChooseheading": "Catering & Delicious Local Cuisine",
    "WhyChoosedescription": "Delight your guests with freshly prepared meals featuring local and regional flavors. The resort’s catering services ensure a memorable culinary experience for your wedding celebrations."
  },
  {
    "WhyChooseheading": "Ideal for Pre-Wedding & Post-Wedding Events",
    "WhyChoosedescription": "Woodland Escape Resort is perfect for hosting pre-wedding photoshoots, mehendi, sangeet, and farewell brunches. The forest setting provides a unique and uninterrupted experience for all wedding-related events."
  },
  {
    "WhyChooseheading": "Easily Accessible from Bhandara",
    "WhyChoosedescription": "Situated near Bhandara, Woodland Escape Resort is easy to reach while still offering the feeling of a secluded retreat. Guests can enjoy a hassle-free journey and arrive ready to celebrate in a serene forest environment."
  }
]

















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort for a destination wedding near Bhandara?",
    answer: "Woodland Escape Resort offers a serene countryside location, spacious event lawns, and accommodation facilities—all close to Bhandara. It’s an ideal destination wedding resort where you can combine ceremony, celebration, and guest stay in one place."
  },
  {
    question: "How far is Woodland Escape Resort from Bhandara city?",
    answer: "The resort is located approximately 40–45 km from Bhandara, which takes around 1 to 1.5 hours by car. It provides guests with near-city access while offering a tranquil, private wedding environment."
  },
  {
    question: "What wedding facilities and event services are offered at the resort?",
    answer: "We provide full wedding event support including venue decoration, banquet/hall & lawn options, in-house catering, accommodation for guests, sound & lighting, and event coordination. Whether you’re planning a grand affair or an intimate celebration, we’ll tailor it for you."
  },
  {
    question: "Can we host pre-wedding functions, ceremony, and post-wedding at the resort?",
    answer: "Absolutely! Woodland Escape Resort is perfect for engagement, mehendi, haldi, sangeet, wedding ceremony, and reception. The property allows you to spread events over 1–2 days so your celebrations flow smoothly and your guests stay comfortably onsite."
  },
  {
    question: "What accommodation options are available for wedding guests?",
    answer: "We offer comfortable rooms, cottages, and suites that can accommodate your wedding guests. The lodging is integrated with the event venue, so your guests don’t have to travel between locations—making it convenient and relaxing."
  },
  {
    question: "How do we book Woodland Escape Resort for a destination wedding near Bhandara?",
    answer: "You can connect with our wedding planning team via phone, WhatsApp, or our website. We recommend booking well in advance — this allows us to customize your wedding package, secure the dates, and manage the event logistics properly."
  }
];

const testimonials = [
  {
    name: "Mr. Rohit & Family, Bhandara",
    text: "Our wedding at Woodland Escape Resort was a dream come true! From the lush green surroundings to the thoughtful accommodation and excellent catering — everything was perfect. Guests were comfortable and the venue added magic to our celebrations."
  },
  {
    name: "Miss. Sneha & Team, Bhandara",
    text: "Choosing Woodland Escape Resort for our destination wedding near Bhandara was the best decision! The lawn looked beautiful, staff was very cooperative, and we could host all functions in one place. Highly recommended for couples wanting something special."
  }
];


















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Destination Wedding Place Near Bhandara",
  "image": "https://woodlandescape.com/assets/images/destination-wedding-bhandara.jpg",
  "description": "Host your dream destination wedding at Woodlandescape Resort — the perfect wedding place near Bhandara. Luxurious venues, scenic outdoor settings, riverside and hill locations, and premium wedding packages for a memorable celebration.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "214"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "49999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/destination-wedding-bhandara"
  }
};



  return (
    <div>
<Helmet>
  <title>Destination Wedding Place Near Bhandara | Scenic & Luxury Venue | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan your dream destination wedding at Woodlandescape Resort — the ideal wedding place near Bhandara with luxurious venues, scenic outdoor settings, riverside and hill locations, and premium wedding packages." 
  />
  <meta 
    name="keywords" 
    content="Destination Wedding Place Near Bhandara, Bhandara Wedding Venue, Bhandara Luxury Wedding Location, Affordable Wedding Spot Bhandara, Bhandara Pre Wedding Shoot Location, Bhandara Outdoor Wedding Spot, Bhandara Riverside Wedding Venue, Bhandara Hill Wedding Location, Bhandara Family Wedding Resort, Bhandara Resort Wedding Packages, Bhandara Wedding Booking Online, Bhandara Wedding Hall, Bhandara Marriage Destination, Bhandara Resort for Wedding, Bhandara Wedding Destination Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/19.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Destinationweddingplacenearbhnadara;